import React from 'react';
import PropTypes from 'prop-types';
import withLocalization from '../higherOrderComponents/withLocalization';
import { UnorderedList } from '../lists/UnorderedList';
import CustomMeter from './CustomMeter';

const ProgressMeter = ({ translate, steps, currentStepIndex }) => {
  const lastStep = steps.length - 1;

  const meterProps = {
    min: 0,
    max: lastStep,
    value: currentStepIndex > lastStep ? lastStep : currentStepIndex,
    title: translate('progress-indicator-title')
  };

  return (
    <div className='progress-meter-wrap'>
      <CustomMeter meterProps={meterProps} />
      <UnorderedList
        title={translate('list-steps-title')}
        ariaRelevant={['all']}
        htmlAttributes={{
          className: 'progress-step-list'
        }}
      >
        {steps.map(({ stepName, content }, index) => {
          const listItemClasses = [];

          if (index === currentStepIndex) {
            listItemClasses.push('active');
          }

          return (
            <li className={listItemClasses.join(' ')} key={`progress-label-${stepName}`}>
              {content}
            </li>
          );
        })}
      </UnorderedList>
    </div>
  );
};

ProgressMeter.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepName: PropTypes.string.isRequired,
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
      ]).isRequired
    })
  ).isRequired,
  currentStepIndex: PropTypes.number.isRequired
};

export default withLocalization(ProgressMeter, 'elements/progressMeter');